"use strict";
(function (global) {

  global.explorer = {
    _jMainContainer: null,
    _jFilterContainer: null,
    _jSpinner: null,

    /**
     * Инициализирует проводник.
     *
     * @method Core.pages.explorer.init
     */
    init: function () {
      var me = this;

      // TODO перенести в текущий объект
      InitToolbar();
      InitExplorerSidebar();
      InitFolderCover();
      window.name = 'explorer';

      // Установить текущее состояние для истории, если его еще нет.
      me.setCurrentState();

      // Обновление содержимого окна.
      WA.history.bind(WA.history.EVENT.CHANGE_STATE, function (state) {
        if (state && state.type === 'explorer' && state.folderID) {
          me.openFolder(state);
        } else {
          // Если state не определен - перезагружаем окно.
          window.location.reload();
        }
      });

      me._jMainContainer = $('#main_container .MainContentPlaceHolder');
      me._jFilterContainer = $("#QFilter");
      me._jSpinner = $('#main_container .explorer-spinner');

      me._initFolderTreeScroll();
      me._initExpandFoldertree();
    },

    /**
     * Загружает указанную папку.
     *
     * @method Core.pages.explorer.openFolder
     * @param {object} folder
     */
    openFolder: function (folder) {
      var me = this;

      me._jMainContainer.empty();
      me._showSpinner();

      WA.SRV.call('/Folder.asmx/ContentAsHtml', {
        'FolderId': folder.folderID,
        'ShowCover': !!folder.hasCover,
        'IsCoverOnly': !!folder.hasCoverOnly
      }).done(function (content) {
        WA.CR.ID = folder.folderID;

        // Панель фильтрации
        me._jFilterContainer.html(content.Filter);
        if (content.FilterJs)
          _exec(content.FilterJs);
        Core.footer
          .initFastSearchFilter()
          .initViewSwitchingMenu();
        Core.toolBars.objectList.initPreFiltersMenu();

        // Основной контент.
        me._jMainContainer.html(content.Main);
        if (content.MainJs)
          _exec(content.MainJs);
        me._hideSpinner();

        // Выделить узел дерева
        if (folder.path)
          WA.CR.folderTree.selectNodeByPath(folder.path);

        // Обновить счетчик непрочитанных для текущей папки
        WA.CR.folderTree.updateUnreadJobCount(folder.folderID, false);

        // Заголовок
        me.setTitle(folder.title);

        // Применить кастомные стили для обложки
        var jRightColumn = $("#right_column");
        var hasCoverSelector = "folder_has_cover";
        if (folder.hasCover) {
          var jCoverFrame = $('#folder_cover_frame');
          changeCoverStylesImages(jCoverFrame);
          jRightColumn.addClass(hasCoverSelector);
        } else {
          jRightColumn.removeClass(hasCoverSelector);
        }

        //Если текущая папка допускает в качестве контента только ЗЗУ, то скрываем кнопку экспортировать документ.
        if (folder.contentType === 'Job') {
          WA.CR.toolBar.buttons["ExportDoc"].hide();
          WA.CR.toolBar.buttons["MarkAsRead"].show();
        } else if (folder.contentType === 'EDocument') {
          //Если текущая папка допускает в качестве контента только документы, то скрываем кнопку пометить как прочитанное.
          WA.CR.toolBar.buttons["MarkAsRead"].hide();
          WA.CR.toolBar.buttons["ExportDoc"].show();
        } else if (folder.contentType === 'ComponentToken' || folder.contentType === 'Task') {
          //Если текущая папка допускает в качестве контента только варианты запуска, то скрываем кнопки пометить как прочитанное и  экспортировать документ.
          WA.CR.toolBar.buttons["MarkAsRead"].hide();
          WA.CR.toolBar.buttons["ExportDoc"].hide();
        } else {
          WA.CR.toolBar.buttons["MarkAsRead"].show();
          WA.CR.toolBar.buttons["ExportDoc"].show();
        }

        // Пересчитать размеры элементов
        setRealHeightAndWidth();
      }).fail(function (msg) {
        WA.CR.inlineHint.showError(msg);
      });

      function _exec(func) {
        var f = new Function(func);
        setTimeout(function () {
          f.apply(window);
        }, 10);
      }
    },

    /**
     * Устанавливает заголовок текущего окна проводника.
     *
     * @method Core.pages.explorer.setTitle
     * @param {} title
     * @returns {}
     */
    setTitle: function (title) {
      window.document.title = title;
      var folderTitle = $('.explorer-folder-name');
      folderTitle.text(title);
      folderTitle.attr('title', title);
    },

    /**
    * Возвращает заголовок текущего окна проводника.
    *
    * @method Core.pages.explorer.setTitle
    * @returns {}
    */
    getTitle: function (title) {
      return $('.explorer-folder-name').text();
    },


    /**
     * Обновляет текущий список и узел для текущей папки.
     *
     * @method Core.pages.explorer.refreshList
     */
    refreshList: function () {
      var me = this;
      var id = WA.CR.getID();
      me._showSpinner();
      WA.CR.objectList.reload().done(function () {
        WA.CR.folderTree.updateNodesWithFolder(id);
        WA.CR.folderTree.updateUnreadJobCount(id, true);
        me._hideSpinner();
      });
    },

    /**
     * Устанавливает history state для текущей страницы проводника.
     *
     */
    setCurrentState: function () {
      // Не устанавливаем текущее состояние для страниц поиска, чтобы при возвращении назад выполнялся поиск.
      if (!history.state && location.href.toLowerCase().search('mode=search') < 0) {
        var jMainContainer = $('#main_container .MainContentPlaceHolder');
        var id = WA.CR.getID();
        var title = this.getTitle();
        // Если нет контейнера для списка, то значит в режиме папки.
        var hasCover = jMainContainer.find('.object_contents').length === 0;
        // QFilter пустой, если режим "Только обложка"
        var hasCoverOnly = hasCover && $('#QFilter').children().length === 0;
        var url = new WA.URL();
        var fpath = url.getParam('fpath');

        WA.history.replaceState({
          type: 'explorer',
          folderID: id,
          title: title,
          path: fpath,
          hasCover: hasCover,
          hasCoverOnly: hasCoverOnly
        }, title, url.asString());
      }
    },

    /*
      * Выполняет быстрый поиск.
      * @method Core.pages.explorer.executeQuickSearch
    */
    executeQuickSearch: function (value) {
      // TODO: Произвести запись в клиентскую статистику.
      var f = $("form:first");
      var url = f.attr('action');

      ShowTopSpinner(L("SEARCHING"));

      url = ChangeParamInURL(url, 'searchname', 'SrchQuick');
      url = ChangeParamInURL(url, 'mode', 'search');
      url = RemoveParamInURL(url, 'show');
      url = ChangeParamInURL(url, 'value', value);
      url = ChangeParamInURL(url, 'sort', '-RANK');
      url = RemoveParamInURL(url, 'uid');
      url = RemoveParamInURL(url, 'refcode');
      url = RemoveParamInURL(url, 'treeitem');

      f.attr('action', url);
      f.submit();
    },

    /**
    * Скрыть область с деревом папки
    * @private
    */
    collapseFolderTree: function () {
      $.when(WA.SideBarInit).then(function () {
        WA.CR.sideBar.collapse();
      });
    },
    /**
    * Раскрытие области с деревом папки
    * @private
    */
    expandFolderTree: function () {
      $.when(WA.SideBarInit).then(function () {
        WA.CR.sideBar.expand();
      });
    },

    /**
     * Отображает спиннер.
     * @private
     */
    _showSpinner: function () {
      var me = this;
      me._jMainContainer.hide();
      me._jSpinner.show();
    },

    /**
     * Скрывает спиннер.
     * @private
     */
    _hideSpinner: function () {
      var me = this;
      me._jMainContainer.show();
      me._jSpinner.hide();
    },

    /**
     * Инициализирует действие раскрытия области с деревом папок.
     * @private
     */
    _initExpandFoldertree: function () {
      var me = this;
      $("#expand_tree_container, .explorer-header__expand-area").click(function () {
        me.expandFolderTree();
      });
    },

    /**
     * Заменяет стандартный скролл у дерево папок.
     * @private
     */
    _initFolderTreeScroll: function () {
      $("#tree_container").niceScroll({
        cursorcolor: "#d8dce3",
        cursorwidth: "6px",
        cursorborder: "0",
        autohidemode: "false",
        cursorborderradius: "0",
        railpadding: { right: 0 }
      });
    },

    /**
     * Инициализирует кнопку отображения папок в списке страницы.
     * @private
     */
    _initShowFolderInList: function () {

      // Инициализирует клик по кнопке Показать/Скрыть папки в списке.
      function bindShowFoldersInListClick() {
        $("#ShowFoldersInList").bind('click', function () {
          var jShowFoldersInListButton = $("#ShowFoldersInList");
          var selectedSelector = "selected";
          var currentFolderID = WA.current.getID();
          var currentNeedToShow = !jShowFoldersInListButton.hasClass(selectedSelector);

          WA.services.call("/Session.asmx/UpdateShowFoldersInList", {
            FolderID: currentFolderID,
            NeedToShow: currentNeedToShow
          }).success(function (result) {
            if (currentNeedToShow) {
              jShowFoldersInListButton.addClass(selectedSelector)
              WA.CR.objectList.setIsShowFolders(true);
            } else {
              jShowFoldersInListButton.removeClass(selectedSelector);
              WA.CR.objectList.setIsShowFolders(false);
            }
            WA.CR.objectList.loadFolderContent(currentFolderID);
          });
        });
      };

      bindShowFoldersInListClick();

      WA.current.objectList
        .bind('onChange', function (selectedItems, allItems) {

          var jShowFoldersInListButton = $("#ShowFoldersInList");
          var selectedSelector = "selected";

          if (location.href.toLowerCase().search('mode=search') < 0) {
            bindShowFoldersInListClick();
            if (WA.CR.objectList.isShowFolders())
              jShowFoldersInListButton.addClass(selectedSelector);
            else
              jShowFoldersInListButton.removeClass(selectedSelector);
          } else {
            jShowFoldersInListButton.hide();
            jShowFoldersInListButton.prev().hide();
          }
        });
    },

    /**
     * Устанавливает состояние Selected/Unselected кнопок отображения папок в списке страницы.
     * @private
     */
    _setShowFolderInListState: function () {
      var jShowFoldersInListButton = $("#ShowFoldersInList");
      var selectedSelector = "selected";

      if (location.href.toLowerCase().search('mode=search') < 0) {
        if (WA.CR.objectList.isShowFolders())
          jShowFoldersInListButton.addClass(selectedSelector);
        else
          jShowFoldersInListButton.removeClass(selectedSelector);
      } else {
        jShowFoldersInListButton.hide();
        jShowFoldersInListButton.prev().hide();
      }
    }
  };
})(window.Core.pages)
